import api from './api'

export const shippingService = {
  // The 27 Egyptian governorates — the building blocks of a zone
  getGovernorateCatalog: async () => {
    const res = await api.get('/shipping/governorates/catalog')
    return res.data.data
  },

  // Zones
  getZones: async () => {
    const res = await api.get('/shipping/zones')
    return res.data.data
  },
  createZone: async (data) => {
    const res = await api.post('/shipping/zones', data)
    return res.data.data
  },
  updateZone: async (id, data) => {
    const res = await api.patch(`/shipping/zones/${id}`, data)
    return res.data.data
  },
  deleteZone: async (id) => {
    await api.delete(`/shipping/zones/${id}`)
  },

  // Shipping classes
  getClasses: async () => {
    const res = await api.get('/shipping/classes')
    return res.data.data
  },
  createClass: async (data) => {
    const res = await api.post('/shipping/classes', data)
    return res.data.data
  },
  updateClass: async (id, data) => {
    const res = await api.patch(`/shipping/classes/${id}`, data)
    return res.data.data
  },
  deleteClass: async (id) => {
    await api.delete(`/shipping/classes/${id}`)
  },
  getClassCategories: async (id) => {
    const res = await api.get(`/shipping/classes/${id}/categories`)
    return res.data.data
  },
  setClassCategories: async (id, categoryIds) => {
    const res = await api.put(`/shipping/classes/${id}/categories`, { categoryIds })
    return res.data.data
  },

  // Methods
  getMethods: async (params = {}) => {
    const res = await api.get('/shipping/methods', { params })
    return res.data.data
  },
  createMethod: async (data) => {
    const res = await api.post('/shipping/methods', data)
    return res.data.data
  },
  updateMethod: async (id, data) => {
    const res = await api.patch(`/shipping/methods/${id}`, data)
    return res.data.data
  },
  deleteMethod: async (id) => {
    await api.delete(`/shipping/methods/${id}`)
  },

  // Admin: list all shipments
  getShipments: async (params = {}) => {
    const res = await api.get('/shipping/shipments', { params })
    return res.data
  },

  updateShipment: async (id, data) => {
    const res = await api.patch(`/shipping/shipments/${id}`, data)
    return res.data.data
  },
}
